import { useEffect, useRef, useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import jwt_decode from "jwt-decode";
import Select from "react-select";
import ClientCaptcha from "react-client-captcha";
import backgroundImage from "../../images/background-1.png";
import logoImage from "../../images/MyChurchGPT-LOGO.png";
import io from "socket.io-client";

import SecondaryRole from "./SecondaryRole";
//Global State using JOTAI
import { useAtom } from "jotai";
import { gbState, globalUserStatus } from "../../components/shared/GlobalState";

const Login = () => {
  let navigate = useNavigate();
  //let socket;
  const [userStatus, setUserStatus] = useAtom(gbState);
  const [userGlobal, setUserGlobal] = useAtom(globalUserStatus);
  const [roleOptions, setRoleOptions] = useState([
    {
      value: "CHURCH_ADMIN",
      label: "Church Admin",
    },
    {
      value: "MEMBER",
      label: "Church Member",
    },
  ]);

  const [loggedUser, setLoggedUser] = useState(null);
  const [state, setState] = useState({ captchaCode: "", valid: "a" });
  //const { captchaCode } = state;
  const [matches, setMatches] = useState(
    window.matchMedia("(min-width: 768px)").matches
  );

  const [captchaWidth, setCaptchaWidth] = useState(300); // Increased from 220

  let usernameRef = useRef();
  let passwordRef = useRef();
  let captchaRef = useRef();
  let userToken = localStorage.getItem("token");

  // Maintain a single socket instance
  const socketRef = useRef(null);

  const setCode = (captchaCode) => {
    setState({ ...state, captchaCode });
  };

  const checkLogin = async (email, password) => {
    // console.log(process.env.REACT_APP_API_URL);
    const credentials = { email, password };
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/user/login`,
      credentials
    );

    return response;
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();

    //alert(usernameRef.current.value + " pass: " + passwordRef.current.value);
    if (state.valid !== state.captchaCode) {
      toast.error("Unable to login, Bad Captcha");
      captchaRef.current.focus();
      return;
    }

    if (usernameRef.current.value && passwordRef.current.value) {
      try {
        const response = await checkLogin(
          usernameRef.current.value,
          passwordRef.current.value
        );
        //console.log(JSON.stringify(await response));
        localStorage.setItem("token", response.data.authToken);

        setInterval(checkToken, 1000 * 60 * 10);
        const user = jwt_decode(response.data.authToken);
        // console.log(user);
        setLoggedUser(jwt_decode(response.data.authToken));

        setUserStatus({
          ...userStatus,
          user: jwt_decode(response.data.authToken),
          handleLogout: () => {
            localStorage.removeItem("token");
            sessionStorage.removeItem("user-details");
            setUserStatus({ ...userStatus, user: null });
            // Properly disconnect the socket
            if (socketRef.current) {
              socketRef.current.disconnect();
            }
            navigate("/login", { replace: true });
          },
        });

        setUserGlobal({ ...jwt_decode(response.data.authToken) });

        if (user.role === "FULL_ACCESS") {
          navigate("/churchonboard", { replace: true });
        } else if (user.role === "CHURCH_ADMIN") {
          navigate("/v1/dashboard-ca", { replace: true });
        } else if (user.secondary_role === "CHURCH_ADMIN") {
          navigate("/secondary-admin", { replace: true });
        } else if (
          user.role === "SUB_MEMBER" &&
          user.secondary_role === "CHURCH_ADMIN"
        ) {
          navigate("/secondary-admin", { replace: true });
        } else if (
          user.role === "CHURCH_MEMBER" ||
          user.role === "SUB_MEMBER"
        ) {
          navigate("/member/dashboard", { replace: true });
        }
        toast.success("Logged in successfully");
      } catch (error) {
        toast.error("Unable to login, Bad username or password");
      }
    }
  };

  const checkToken = () => {
    const token = localStorage.getItem("token");
    if (token) {
      const decodedToken = jwt_decode(token);
      const currentTime = Date.now() / 1000;
      if (decodedToken.exp < currentTime) {
        // token has expired, do something here (e.g. log out the user)
        localStorage.removeItem("token");
        sessionStorage.removeItem("user-details");
        setUserStatus({ ...userStatus, user: null });
        navigate("/login", { replace: true });
      }
    }
  };

  return (
    <div style={styles.background}>
      <div style={styles.loginCard}>
        <img src={logoImage} alt="CMS Logo" style={styles.logo} />
        <form onSubmit={handleLoginSubmit} style={styles.form}>
          <div style={styles.inputGroup}>
            <label htmlFor="emailaddress" style={styles.label}>
              Email Address
            </label>
            <input
              type="email"
              id="emailaddress"
              name="emailaddress"
              required
              placeholder="Enter your email"
              autoComplete="new-password"
              ref={usernameRef}
              style={styles.input}
            />
          </div>
          <div style={styles.inputGroup}>
            <label htmlFor="password" style={styles.label}>
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              required
              placeholder="Enter your password"
              autoComplete="new-password"
              ref={passwordRef}
              style={styles.input}
            />
          </div>
          <div style={styles.captchaContainer} className="mt-3">
            <div style={styles.captchaRow}>
              <div style={{ ...styles.captcha, width: "50%" }}>
                <ClientCaptcha
                  captchaCode={setCode}
                  width={150}
                  style={{
                    borderRadius: "8px",
                    overflow: "hidden",
                    border: "1px solid #ccc",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    width: "100%",
                  }}
                  charsCount={6}
                  chars="0123456789"
                  backgroundColor="#ffffff"
                  fontColor="#000000"
                  fontSize={20}
                  canvasClassName="rounded-captcha"
                  refreshIconColor="#ffffff"
                  refreshIconStyle={{ color: "#ffffff" }}
                />
              </div>
              <input
                type="text"
                id="captcha"
                name="captcha"
                placeholder="Enter Captcha"
                onChange={(e) => setState({ ...state, valid: e.target.value })}
                ref={captchaRef}
                onKeyPress={(e) => e.key === "Enter" && handleLoginSubmit(e)}
                autoComplete="off"
                style={{
                  ...styles.input,
                  width: "50%",
                  marginLeft: "10px",
                }}
              />
            </div>
          </div>
          <div className="flex flex-col gap-4 justify-end items-center mt-4 md:flex-row">
            <button
              type="submit"
              className="px-6 py-2 w-full font-semibold text-white bg-blue-600 rounded-lg shadow-md transition duration-300 ease-in-out md:w-1/2 hover:bg-blue-700"
            >
              Login
            </button>
          </div>
          <div className="">
            <NavLink to="" style={styles.forgotPassword}>
              Forgot your password?
            </NavLink>
          </div>
        </form>
        <div style={styles.buildVersion}>BUILD: v.220240117110.0</div>
      </div>
    </div>
  );
};

export default Login;

const styles = {
  background: {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    minHeight: "100vh",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  loginCard: {
    backgroundColor: "rgba(0, 31, 63, 0.9)",
    color: "#ffffff",
    padding: "40px",
    borderRadius: "10px",
    boxShadow: "0 15px 30px rgba(0, 0, 0, 0.5)",
    maxWidth: "520px",
    width: "100%",
    margin: "20px",
  },
  logo: {
    display: "block",
    margin: "0 auto 30px",
    maxWidth: "180px",
    height: "auto",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  inputGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  label: {
    color: "#87ceeb",
    fontWeight: "600",
    fontSize: "14px",
  },
  input: {
    width: "100%",
    padding: "10px 12px",
    backgroundColor: "#003366",
    color: "#ffffff",
    border: "1px solid #4682b4",
    borderRadius: "4px",
    fontSize: "16px",
    transition: "all 0.3s ease",
    "&:focus": {
      borderColor: "#87ceeb",
      boxShadow: "0 0 0 2px rgba(135, 206, 235, 0.3)",
      outline: "none",
    },
  },
  captchaContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
  },
  captcha: {
    width: "100%",
    display: "flex",
    justifyContent: "start",
  },
  actionContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "10px",
  },
  forgotPassword: {
    color: "#87ceeb",
    textDecoration: "none",
    fontSize: "14px",
    transition: "color 0.3s ease",
    "&:hover": {
      color: "#ffffff",
      textDecoration: "underline",
    },
  },
  loginBtn: {
    padding: "12px 25px",
    backgroundColor: "#4682b4",
    color: "#ffffff",
    border: "none",
    borderRadius: "5px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "0 6px 12px rgba(0, 0, 0, 0.2)",
    "&:hover": {
      backgroundColor: "#5693c5",
      transform: "translateY(-2px)",
      boxShadow: "0 8px 16px rgba(0, 0, 0, 0.25)",
    },
    "&:active": {
      transform: "translateY(0)",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
    },
  },
  buildVersion: {
    marginTop: "30px",
    fontSize: "10px",
    color: "#87ceeb",
    textAlign: "center",
  },
  captchaRow: {
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
};
